module.exports = __webpack_public_path__ + "img/style.447ea3ea.png";